import {CookieService} from './cookies';
import 'jquery-autocomplete/jquery.autocomplete';

$(document).ready(() => {
    if (CookieService.IsGdprAccepted()){

        $('[data-search-track-trigger]').parent().on('resultsUpdate', function(){
            trackResearchPage();
        });

        if ($('[data-search-value]').length > 0) {
            trackResearchPage();
        }

        $('[data-search-container]').parent().on('click', '[data-query-click-trigger]', (item) => {
            trackSearchPageClick(item);
        });

    }

    $('[data-search-input], [data-header-search-input]').autocomplete({
        appendMethod:'replace', 
        showHint: false,
        source:[ 
            function(q, add){

                if (this.delay) clearTimeout(this.delay);

                this.delay = setTimeout(()=> {
                    if (q) {
                        $.getJSON("/api/search/suggestions?prefix="+encodeURIComponent(q),function(resp){
                            add(resp)
                        })
                    } else {
                        add([]);
                    }
                }, 1000);
            },
        ],
    }).on('selected.xdsoft', function(e, data) {
        const form = $(e.currentTarget).closest('form');
        form.submit();
    });
});

function trackSearchPageClick(item) {
    const hitId = $(item.currentTarget).data('query-click-trigger')
    const query = $('[data-search-value]').data('search-value');
    const hitPosition = $(item.currentTarget).data('query-result-position');
    $.ajax({
        method: "POST",
        url: '/api/search/trackhit',
        data: {hitId, query, hitPosition}
    });
}

function trackResearchPage() {
    const query = $('[data-search-value]').data('search-value');
    const totalMatching = $('[data-search-total-matching]').data('search-total-matching');
    $.ajax({
        method: "POST",
        url: '/api/search/trackquery',
        data: {query, totalMatching}
    });
}